<script lang="ts" setup>
import TableSchedule from './table-schedules.vue'
import { getSportGames } from '~/resources/sports'
import { useSwiper } from '~/composables/common/use-swiper'
import LoadingSpin from '~common/loading-spin.vue'
import SliderNavigation from '~/components/common/slider-navigation.vue'
import HotMatchCard from '~common/hot-match/hot-match-card.vue'
import { LOBBY_GAME_URLS } from '~/configs/page-url'
import { useHotmatches } from '~/composables/home/use-hotmatches'
import { useSports } from '~/composables/sports/use-sports'

const { modules } = useSwiper()
const { playSport } = useSports()
const { hotmatches, isLoadingHotmatch } = useHotmatches()

defineProps({
  slidesPerView: {
    type: Number,
    default: 3
  },
  spaceBetween: {
    type: Number,
    default: 24
  },
  isShowTableSchedules: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
  <div class="content-schedules">
    <div v-if="!isShowTableSchedules" class="sports-highlight">
      <template v-for="(sport, index) in getSportGames()" :key="sport.id">
        <div
          v-if="!sport.isHideOnDesktop"
          :class="[
            'sports-highlight__item',
            `item-${index + 1}`,
            { 'coming-soon': sport.isMaintain, ratio: index !== 0 }
          ]"
          @click.prevent="playSport(sport)"
        >
          <div>
            <NuxtImg
              :src="sport.imageUrl"
              class="sports-highlight__item__img"
              :alt="sport.alias"
              densities="x1 x2"
              preload
            />
          </div>

          <div v-if="!sport.isMaintain" class="hover-shine__wrapper">
            <div class="hover-shine"></div>
          </div>

          <div class="label-sport">
            <NuxtImg
              v-if="sport.imgLabel || (sport.isMaintain && sport.labelMaintance)"
              :src="sport.isMaintain ? sport.labelMaintance : sport.imgLabel"
              alt="Icon label"
              densities="x1 x2"
              preload
            />
          </div>
        </div>
      </template>
    </div>
    <TableSchedule v-if="isShowTableSchedules" />
    <ClientOnly v-if="!isShowTableSchedules">
      <LoadingSpin v-if="isLoadingHotmatch" />
      <div v-else class="schedules">
        <div class="schedules__content">
          <div class="schedules__title">
            <div
              v-if="hotmatches?.length > 3"
              class="match-swiper-btns w-100 d-flex justify-content-between align-items-center"
            >
              <h2 class="base-title__text">TRẬN CẦU HOT</h2>
              <div class="schedules-wrapper-header">
                <NuxtLink :to="LOBBY_GAME_URLS.SCHEDULES" class="schedules-view-more">
                  <img src="/assets/images/icons/icon-calendar.svg" class="icon-calendar" alt="icon calendar" />
                  Xem lịch thi đấu
                </NuxtLink>
                <SliderNavigation />
              </div>
            </div>
          </div>

          <template v-if="hotmatches?.length && !isLoadingHotmatch">
            <div class="match-wrapper">
              <Swiper
                v-if="hotmatches?.length"
                :modules="modules"
                :slidesPerView="slidesPerView"
                loop
                :autoplay="{
                  delay: 10000
                }"
                :navigation="{
                  nextEl: '.schedules .slider-navigation__next',
                  prevEl: '.schedules .slider-navigation__prev'
                }"
                :spaceBetween="spaceBetween"
              >
                <SwiperSlide v-for="(hotmatch, index) in hotmatches" :key="`hot-match+${index}`">
                  <HotMatchCard :hotmatch="hotmatch" />
                </SwiperSlide>
              </Swiper>
            </div>
          </template>
          <div v-else class="no-data">
            <div class="no-data__image">
              <NuxtImg
                format="webp"
                src="/assets/images/icons/icon-nodata-sports.png"
                alt="Icon News"
                width="108"
                height="108"
                densities="1x"
                preload
              />
            </div>
            <div class="no-data__title">Lịch thi đấu đang được cập nhật</div>
          </div>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/pages/sports/schedules.scss';
</style>
